/**
 * SIMPLE CALCULATOR COMPONENT
 *
 * Features:
 * - Basic arithmetic operations
 * - Quick calculations for transaction inputs
 */

import React, { useState } from 'react';
import { X } from 'lucide-react';

const SimpleCalculator = ({ onResult, onClose }) => {
  const [display, setDisplay] = useState('0');
  const [expression, setExpression] = useState('');

  const handleNumber = (num) => {
    setDisplay(prev => prev === '0' ? num.toString() : prev + num);
  };

  const handleOperator = (op) => {
    setExpression(display + ' ' + op + ' ');
    setDisplay('0');
  };

  const calculate = () => {
    try {
      const fullExpr = expression + display;
      const result = eval(fullExpr); // Safe for simple calculator
      setDisplay(result.toString());
      setExpression('');
      if (onResult) onResult(result);
    } catch {
      setDisplay('Error');
      setExpression('');
    }
  };

  const clear = () => {
    setDisplay('0');
    setExpression('');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm">
        {/* Header */}
        <div className="bg-blue-600 px-4 py-3 flex items-center justify-between rounded-t-xl">
          <h3 className="text-lg font-bold text-white">Kalkulator</h3>
          <button onClick={onClose} className="text-white hover:bg-white/20 p-1 rounded">
            <X size={20} />
          </button>
        </div>

        {/* Display */}
        <div className="p-4 bg-gray-900">
          {expression && (
            <div className="text-right text-gray-400 text-sm mb-1">{expression}</div>
          )}
          <div className="text-right text-white text-3xl font-bold font-mono">
            {display}
          </div>
        </div>

        {/* Buttons */}
        <div className="p-3 grid grid-cols-4 gap-2">
          <button onClick={clear} className="col-span-2 py-3 bg-red-500 text-white rounded font-bold">C</button>
          <button onClick={() => handleOperator('/')} className="py-3 bg-blue-500 text-white rounded font-bold">÷</button>
          <button onClick={() => handleOperator('*')} className="py-3 bg-blue-500 text-white rounded font-bold">×</button>

          {[7, 8, 9].map(n => (
            <button key={n} onClick={() => handleNumber(n)} className="py-3 bg-gray-200 rounded font-bold">{n}</button>
          ))}
          <button onClick={() => handleOperator('-')} className="py-3 bg-blue-500 text-white rounded font-bold">−</button>

          {[4, 5, 6].map(n => (
            <button key={n} onClick={() => handleNumber(n)} className="py-3 bg-gray-200 rounded font-bold">{n}</button>
          ))}
          <button onClick={() => handleOperator('+')} className="py-3 bg-blue-500 text-white rounded font-bold">+</button>

          {[1, 2, 3].map(n => (
            <button key={n} onClick={() => handleNumber(n)} className="py-3 bg-gray-200 rounded font-bold">{n}</button>
          ))}
          <button onClick={calculate} className="row-span-2 py-3 bg-green-500 text-white rounded font-bold">=</button>

          <button onClick={() => handleNumber(0)} className="col-span-2 py-3 bg-gray-200 rounded font-bold">0</button>
          <button onClick={() => setDisplay(prev => prev + '.')} className="py-3 bg-gray-200 rounded font-bold">.</button>
        </div>

        {/* Instructions */}
        <div className="px-4 py-2 bg-gray-100 text-center text-xs text-gray-600 rounded-b-xl">
          Klik angka untuk kalkulasi cepat
        </div>
      </div>
    </div>
  );
};

export default SimpleCalculator;
